import { Loader, Select } from '@mantine/core';
import { IconMessage2 } from '@tabler/icons-react';
import { ReactNode } from 'react';

import { nonEmptyGroupsFilter, usePagesOptions } from './usePagesOptions';

import { Departments, Platforms } from '@/types';

type Props = {
  value?: string;
  onSelect: (value: string) => any;
  isLoading?: boolean;
  isDisabled?: boolean;
  disabled?: string[];
  required?: boolean;
  error?: ReactNode | string;
  department?: Departments;
  platform?: Platforms;
};

export const PagesSelect = ({
  value,
  onSelect,
  isLoading,
  isDisabled,
  disabled,
  required,
  error,
  department,
  platform,
}: Props) => {
  const { options, isFetching } = usePagesOptions({ platform, department, disabled });

  const isShowingLoader = isLoading || isFetching;

  return (
    <Select
      disabled={isDisabled}
      required={required}
      value={value}
      comboboxProps={{
        withinPortal: true,
        transitionProps: { transition: 'pop', duration: 200, timingFunction: 'ease' },
      }}
      data={options}
      filter={nonEmptyGroupsFilter}
      placeholder="Pick a page to add"
      searchable
      rightSection={isShowingLoader ? <Loader size="xs" /> : null}
      leftSection={<IconMessage2 size="1rem" />}
      onChange={(value) => value && onSelect(value)}
      error={error}
    />
  );
};
